;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { TERMS_ACCEPTANCE_SOURCE } from '@workspace/ui/lib';
import type { ApiResponse, TermsStatus } from '@workspace/ui/types';
import fetchAPI from '@/lib/fetch-api';

export async function acceptTerms(): Promise<ApiResponse<TermsStatus>> {
  const apiUrl = process.env.NEXT_PUBLIC_SSO_API_URL;

  if (!apiUrl) {
    throw new Error('NEXT_PUBLIC_SSO_API_URL environment variable is not set');
  }

  const response = await fetchAPI<TermsStatus>(`${apiUrl}/terms/accept`, {
    method: 'POST',
    body: JSON.stringify({ source: TERMS_ACCEPTANCE_SOURCE.WEB }),
  });

  return {
    ...response,
    message: response.message || 'Terms accepted successfully',
  };
}
